import Calculator from "../Calculator/Calculator";
import Header from "../Header/Header";
import InvestmentSummaryDisplay from "../InvestmentSummaryDisplay/InvestmentSummaryDisplay";
import Classes from "./App.module.scss";

function App() {
  return (
    <div className={Classes.appWrapper} data-testid="appWrapper">
      <Header />
      <Calculator />
      <InvestmentSummaryDisplay />
    </div>
  );
}

export default App;
